import { render, staticRenderFns } from "./cHeader.vue?vue&type=template&id=2d850a13&scoped=true"
import script from "./cHeader.vue?vue&type=script&lang=js"
export * from "./cHeader.vue?vue&type=script&lang=js"
import style0 from "./cHeader.vue?vue&type=style&index=0&id=2d850a13&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d850a13",
  null
  
)

export default component.exports